// extracted by mini-css-extract-plugin
module.exports = {"ArticleSummary":"ArticleSummary_ArticleSummary__2NREv"};